import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

export const ThreadGetInputsSchema = z.object({
  id: z.string().describe('ID of the thread to retrieve'),
})

export const ThreadGetCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/threads'),
    cmd: z.literal('thread.get'),
    options: z.record(z.string(), z.unknown()).optional(),
  }),
  inputs: ThreadGetInputsSchema,
})

export type ThreadGetCommand = z.infer<typeof ThreadGetCommandSchema>
